// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorPicker_container__31lsB","tabList":"ColorPicker_tabList__3iSql","tab":"ColorPicker_tab__1g2wB","active":"ColorPicker_active__wcfcO"};